import { isSentryEnabled } from '@/sentry';
import * as Sentry from '@sentry/react';

type IgnoredSentryError = {
  message?: string;
  name: string;
};

const IGNORED_SENTRY_ERRORS: IgnoredSentryError[] = [
  {
    name: 'Error',
    message: 'Failed to load the JS script of the agent',
  },
  {
    name: 'FirebaseError',
    message:
      "Messaging: This browser doesn't support the API's required to use the firebase SDK. (messaging/unsupported-browser).",
  },
  {
    name: 'ReferenceError',
    message: '$crisp is not defined',
  },
  {
    name: 'ReferenceError',
    message: "Can't find variable: $crisp",
  },
  {
    name: 'ApolloError',
  },
];

export function shouldIgnoreSentryError(error: unknown) {
  if (!(error instanceof Error)) return false;

  return IGNORED_SENTRY_ERRORS.some((ignoredError) => {
    if (error.name !== ignoredError.name) return false;
    return ignoredError.message === undefined || error.message === ignoredError.message;
  });
}

export function ignoreSentryErrors(event: Sentry.ErrorEvent, hint: Sentry.EventHint): Sentry.ErrorEvent | null {
  return shouldIgnoreSentryError(hint?.originalException) ? null : event;
}

export interface SentryUserInput {
  email?: string | null;
  id?: string | number | null;
  name?: string | null;
  workspaceId?: string | number | null;
}

export function setSentryUser(user: SentryUserInput | null | undefined) {
  if (!isSentryEnabled) return;

  if (!user?.email) {
    Sentry.setUser(null);
    Sentry.setTag('workspaceId', '');
    Sentry.setContext('workspace', null);
    return;
  }

  Sentry.setUser({
    email: user.email,
    id: user.id?.toString(),
    username: user.name ?? undefined,
  });

  if (user.workspaceId !== undefined) {
    if (user.workspaceId === null || user.workspaceId === '') {
      Sentry.setTag('workspaceId', '');
      Sentry.setContext('workspace', null);
      return;
    }

    const workspaceId = user.workspaceId.toString();
    Sentry.setTag('workspaceId', workspaceId);
    Sentry.setContext('workspace', {
      id: workspaceId,
    });
  }
}
